<template>
  <!-- 有edit和build区分的附件提交表单 -->
  <div class="cmsFileTable">
    <van-form ref="fileForm">
      <div class="file-row" v-for="(fileRow, index) in table" :key="index">
        <template v-if="buttonUploadShow(fileRow)">
          <div>
            <div class="file-title">
              <van-field
                :show-error="false"
                class="file-name-field"
                v-model="fileRow.name"
                :rules="[{ required: true, message: '请填写附件名称' }]"
              />
              <img
                @click="deleteFujian(index)"
                :src="require('@/assets/images/public/delete.png')"
                alt=""
              />
            </div>
            <van-field :rules="[{ required: true, message: '请上传附件' }]">
              <template #input>
                <!--附件-->
                <van-uploader
                  v-model="fileRow.file"
                  :after-read="beforeUpload"
                  :name="index"
                  :preview-full-image="false"
                  class="uploader"
                  accept="image/*,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  @click-preview="imageView"
                  :before-delete="(file) => beforeDelteFile(file)"
                >
                  <template #default>
                    <div class="uploaderDiv">
                      <img src="/static/images/public/uploader.png" alt="" />
                    </div>
                  </template>
                </van-uploader>
              </template>
            </van-field>
          </div>
        </template>
        <template v-else>
          <div class="file-title">
            <div class="readonly-field">{{ fileRow.name }}</div>
          </div>
          <template v-for="item in fileRow.file">
            <img
               v-if="!item.isImage"
                :src="$publicJs.filesTypeFilter(item.realName, '../../../')
                "
                class="fujian"
                alt=""
                @click="imageView(item)"
              />
              <img
                v-else
                @click="imageView(item)"
                :src="item.url"
                alt=""
                class="fujian"
              />
          </template>     
        </template>
      </div>
    </van-form>
    <!--图片预览-->
    <van-image-preview
      v-model="show.imageView"
      :images="imageParam.list"
      :loop="false"
      :startPosition="imageParam.index"
    />
    <pdfShow
      :isModel="true"
      @closePdfModel="
        () => {
          isShowPdf = false;
        }
      "
      class="pdf"
      v-if="isShowPdf"
    />
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import pdfShow from "@/components/homePage/pdfShow/pdfShow.vue";
export default {
  name: "cmsFileTable",
  components: {
    pdfShow,
  },
  props: {
    buildUnitTable: {
      type: Array,
      default: [],
    },
    detailType: {
      type: String,
      default: "",
    },
    detailId: {
      type: String,
      default: "",
    },
    fileSystem: {
      type: Object,
      default: {
        sys: "",
        module: "",
        entityClass: "",
        viewByAnon: true,
        longLife: false,
      },
    },
    buttonUploadShow: {
      type: Function,
      default: () => {
        return false;
      },
    },
  },
  watch: {
    buildUnitTable: {
      handler(val) {
        this.$set(this, "table", [...val]);
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isShowPdf: false,
      imageParam: {
        index: 0,
        list: [],
      }, // 图片预览
      show: {
        imageView: false,
      },
      table: [],
      nowFileRow: {},
    };
  },
  methods: {
    beforeDelteFile(file) {
      console.log(file);
      if (file.id && file.attachId) {
        this.unBingFile(file.id, file.attachId);
      }
      return true;
    },
    // 手机端预览文件
    imageView(fileItem) {
      let type = String(
        fileItem.name.split(".")[fileItem.name.split(".").length - 1]
      );
      if (
        type !== "jpg" &&
        type !== "jpeg" &&
        type !== "png" &&
        type !== "svg"
      ) {
        this.previewFile(fileItem.id);
      } else {
        let urls=[]
        this.table.forEach(item=>{
            if(item.file && item.file.length>0){
              item.file.forEach(item2=>{
                let type = String(
                  item2.name.split(".")[item2.name.split(".").length - 1]
                );
                let isImage= type == "jpg" || type == "jpeg" || type == "png" || type == "svg"
                item2.url && isImage && urls.push(item2.url)
              })
            }
        })
        this.imageParam.list=urls
        this.imageParam.index=this.imageParam.list.indexOf(fileItem.url)
        this.show.imageView = true;
        // 如果是图片
        // this.$httpPost(
        //   this.$store.state.httpHost.file +
        //     `/japi/filesystem/getFilePreview?id=${fileItem.id}&browserType=1`
        // )
        //   .then((res) => {
        //     console.log(res, "接口返回值");
        //     console.log(`${this.$store.state.httpHost.base}` + res.data.url);
        //     this.imageParam.list = [
        //       res.data.url.replace("/file", this.$store.state.httpHost.file),
        //     ];
        //     this.show.imageView = true;
        //   })
        //   .catch((res) => {
        //     console.log(res);
        //   });
      }
    },
    previewFile(id) {
      this.$ContinueToast("请稍后，正在转换为pdf预览");
      this.$httpPost(
        `${this.$store.state.httpHost.file}/japi/filesystem/minIoPreview?id=${id}`,
        {}
      )
        .then((res) => {
          this.$toast.clear();
          let type = res.data.data.split(".");
          type = type[type.length - 1];
          sessionStorage.setItem("pdfUrl", Base64.encode(res.data.data));
          this.isShowPdf = true;
          // this.$router.push({
          //   name: "pdfShow",
          // });
        })
        .catch((res) => {
          console.log(res);
          this.$ClearTips();
          console.log(res);
        });
    },
    // 上传文件前
    async beforeUpload(data, otherData) {
      const fileRow = this.table[otherData.name];
      console.log("fileRow", fileRow);
      const { file } = data;
      /*
       *公共上传方法
       * */
      let fd = new FormData();
      fd.append("file", file);
      await this.$httpPost(
        `${this.$store.state.httpHost.file}/japi/filesystem/upload?maxFileSize=${file.size}&viewByAnon=true&longLife=false`,
        fd,
        {
          headers: {
            "Content-Type":
              "multipart/form-data; boundary=----WebKitFormBoundaryIOi8qEBAFV1KN25n",
          },
        }
      )
        .then(async (res) => {
          if (res.data.status === 1) {
            console.log(fileRow);
            const lastFile = fileRow.file[fileRow.file.length - 1];
            const type = String(
              file.name.split(".")[file.name.split(".").length - 1]
            );
            if (lastFile) {
              lastFile.name = file.name;
              lastFile.size = file.size;
              lastFile.url = this.$store.state.httpHost.file + res.data.link;
              lastFile.id = res.data.id;
              lastFile.link = res.data.link;
              lastFile.isImage =
                ["jpg", "jpeg", "png", "svg"].indexOf(type) != -1;
            }
            // 非新建时绑定文件
            if (this.detailType !== "build") {
              await this.bingFileForm(
                [res.data.id],
                fileRow.part,
                this.detailId,
                (res) => {
                  if (res.status === 1) {
                    console.log("bingFileForm", res);
                    const attachId = res.idSet[0] || "";
                    lastFile.attachId = attachId;
                  } else {
                    this.$notify(res.message);
                  }
                }
              );
            }
            // this.change();
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res, "======");
          this.$toast(this.$route.name + "上传文件前-请求失败");
        });
    },
    change() {
      this.$emit("change", JSON.parse(JSON.stringify(this.table)));
    },
    deleteFujian(index) {
      const files = this.table[index].file;
      for (let item of files) {
        this.beforeDelteFile(item);
      }
      this.table.splice(index, 1);
      this.change();
    },
    // 查看文件
    checkFile(file) {
      this.$httpPost(
        this.$store.state.httpHost.file +
          `/japi/filesystem/getFilePreview?id=${file.id}&browserType=1`
      )
        .then((res) => {
          window.open(
            res.data.url.replace("/file", this.$store.state.httpHost.file)
          );
          // window.location.href = res.data.url
        })
        .catch((res) => {
          console.log("请求出现错误", res);
          this.$toast("请求失败!");
        });
    },
    // 获取绑定的附件
    async getFiles( cb) {
      await this.$httpGet(
        `${this.$store.state.httpHost.file}/japi/filesystem/attachment/getFilesByAttach?sys=${this.fileSystem.sys}&module=${this.fileSystem.module}&form=${this.detailId}`
      )
        .then((res) => {
          if (res.data.status === 1) {
            let data = res.data;
            //回调方法
            if (cb) {
              cb(data);
            }
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res, "=========");
          this.$toast("请求失败!");
        });
      this.change();
    },
    bindAllFile(id, callback) {
      this.table.forEach((item) => {
        if(!this.buttonUploadShow(item)){
          return;
        }
        let arr = [];
        if (
          item.file &&
          item.file[0] &&
          item.file[0].id &&
          !item.isLink &&
          !item.link
        ) {
          item.file.forEach((fi) => {
            arr.push(fi.id);
          });
        }
        this.bingFileForm(arr, item.part, id, callback);
      });
    },
    bindAllFileAsync(id) {
      return Promise.all(
        this.table.map((item) => {
          if(!this.buttonUploadShow(item)){
            return Promise.resolve()
          }
          let arr = [];
          if (
            item.file &&
            item.file[0] &&
            item.file[0].id &&
            !item.isLink &&
            !item.link
          ) {
            item.file.forEach((fi) => {
              arr.push(fi.id);
            });
          }
          return this.bingFileForm(arr, item.part, id);
        })
      );
    },
    // 解绑已绑定的文件
    unBingFile(fileId, attachId, callback) {
      this.$httpPost(
        `${this.$store.state.httpHost.file}/japi/filesystem/attachment/removeBindBatch?attachment=${attachId}&fileInfo=${fileId}`
      )
        .then((res) => {
          if (callback) callback();
        })
        .catch((res) => {
          console.log("请求出现错误", res);
          this.$toast("请求失败!");
        });
    },
    // 绑定文件到表单
    bingFileForm(fileIdsArray, part, id, callback) {
      if (fileIdsArray.length === 0) return;
      return this.$httpPost(
        this.$store.state.httpHost.file +
          "/japi/filesystem/attachment/bindBigBatch",
        [
          {
            fileid: fileIdsArray, // 文件列表
            form: id, // 表单
            sys: this.fileSystem.sys,
            module: this.fileSystem.module,
            part: part,
          },
        ]
      )
        .then((res) => {
          if (callback) callback(res.data);
        })
        .catch((res) => {
          console.log("请求出现错误", res);
          // this.$toast("请求失败!");
        });
    },
    checkForm() {
      return this.$refs.fileForm.validate;
    },
  },
};
</script>

<style scoped lang="scss">
.pdf {
  position: fixed;
  max-height: 100%;
  overflow-y: auto;
  background-color: #fff;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-overflow-scrolling: touch;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2062;
}
.cmsFileTable {
  .readonly-field {
    font-size: 10px;
    color: #222222;
  }
    .fujian {
    width:100px;
    height: 100px;
    margin-bottom: 16.7px;
    margin-right: 16.7px;
    span {
      text-decoration: underline;
      color: rgba(70, 101, 202, 1);
      overflow: auto;
      width: 100%;
      display: block;
      overflow-wrap: anywhere;
    }
  }
  .file-title {
    display: flex;
    & > div {
      flex: 1;
    }
    img {
      margin-top: 12px;
      width: 20px;
      height: 20px;
      margin-left: 20px;
    }
  }
  .file-name-field {
    border-radius: 3.33px;
    border: 0.33px solid #dcdee1;
    margin-bottom: 11.1px;
  }
  .uploader {
    margin-bottom: 11.1px;
  }
  /deep/ .van-uploader__file {
    width: 75px;
    height: 75px;
    img {
      width: 75px;
      height: 75px;
      vertical-align: middle;
    }
  }
  .uploaderDiv {
    width: 75px;
    height: 75px;
    img {
      width: 75px;
      height: 75px;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/cmscomponents/cmsFileTableCanEdit/cmsFileTableCanEdit.vue